import { defineMessages } from "react-intl";

export const messages = defineMessages({
	invitationList: {
		id: "invitation_list.title",
		defaultMessage: "Meghívó lista"
	},
	name: {
		id: "invitation_list.name",
		defaultMessage: "Név"
	},
	email: {
		id: "invitation_list.email",
		defaultMessage: "Email cím"
	},
	role: {
		id: "invitation_list.role",
		defaultMessage: "Szerepkör"
	},
	generated: {
		id: "invitation_list.generated",
		defaultMessage: "Elküldve"
	},
	expires: {
		id: "invitation_list.expires",
		defaultMessage: "Lejár"
	},
	resend: {
		id: "invitation_list.resend",
		defaultMessage: "Újraküldés"
	},
	delete: {
		id: "invitation_list.delete",
		defaultMessage: "Törlés"
	},
	resendSuccess: {
		id: "invitation_list.resend_success",
		defaultMessage: "Meghívó újraküldve"
	},
	deleteSuccess: {
		id: "invitation_list.delete_success",
		defaultMessage: "Meghívó törölve"
	},
	noContent: {
		id: "invitation_list.no_content",
		defaultMessage: "Nincsenek meghívók"
	}
});
